import PyodideWorker from '../assets/js/pyodide.worker.js'

export default (ctx, inject) => {
  inject('worker', {
    createWorker() {
      return new PyodideWorker()
    },
  })
}
